import React, { useContext } from 'react'

import Resource from './Resource'
import MicrocopyContext from '~contexts/MicrocopyContext'

const Resources = ({
  resources
}) => {
  const microcopy = useContext(MicrocopyContext)

  return (
    <>
      { (resources || []).map(resource => (
        <Resource 
          key={resource.id}
          resource={resource}
          microcopy={microcopy} />
        ))
      }
    </>
  )
}

export default Resources